export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-800 mb-6">고흥꿈트리 소개</h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            전라남도 고흥의 청정 자연 속에서 7개 농가가 하나 되어 만드는 치유마을입니다.
            <br />
            자연의 힘과 농가의 정성이 만나 특별한 힐링 경험을 선사합니다.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src="https://static.readdy.ai/image/d1a0c06a8edb29d2039b650faf22b9bc/678a766f43a76edb7326ea8ffdfcd0d2.jpeg"
              alt="고흥꿈트리 치유마을 전경"
              className="rounded-2xl shadow-2xl object-cover w-full h-96"
            />
          </div>
          
          <div className="space-y-8">
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-leaf-line text-green-600 text-xl"></i>
              </div>
              <div>
                <h4 className="text-xl font-semibold text-gray-800 mb-2">자연 치유</h4>
                <p className="text-gray-600">고흥의 청정 자연환경과 농산물을 활용한 자연 친화적 치유 프로그램</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-group-line text-green-600 text-xl"></i>
              </div>
              <div>
                <h4 className="text-xl font-semibold text-gray-800 mb-2">협동조합</h4>
                <p className="text-gray-600">7개 농가가 함께 만드는 지속가능한 치유마을 생태계</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-heart-line text-green-600 text-xl"></i>
              </div>
              <div>
                <h4 className="text-xl font-semibold text-gray-800 mb-2">맞춤 케어</h4>
                <p className="text-gray-600">개인별 맞춤형 치유 프로그램과 따뜻한 농가의 정성</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-seedling-line text-green-600 text-xl"></i>
              </div>
              <div>
                <h4 className="text-xl font-semibold text-gray-800 mb-2">지역 상생</h4>
                <p className="text-gray-600">지역 농산물과 자원을 활용한 상품 개발 및 유통</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}